<div class="whatsapp-trigger" (click)="clickLink()"></div>
<a class="whatsapp-trigger__link" #whatsappLink target="_blank"></a>
